import { render, staticRenderFns } from "./RegisterFacebookOasys.vue?vue&type=template&id=22de82da&scoped=true"
import script from "./RegisterFacebookOasys.vue?vue&type=script&lang=js"
export * from "./RegisterFacebookOasys.vue?vue&type=script&lang=js"
import style0 from "./RegisterFacebookOasys.vue?vue&type=style&index=0&id=22de82da&prod&scoped=true&lang=css"
import style1 from "./RegisterFacebookOasys.vue?vue&type=style&index=1&id=22de82da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de82da",
  null
  
)

export default component.exports